import { AMZ_SIGN_HEADERS } from '../constants';

export function isPresignedUrl(url: string): boolean {
  if (!url) {
    return false;
  }

  try {
    const urlObject = new URL(url);

    return [...urlObject.searchParams.keys()].some(
      (key) => key === AMZ_SIGN_HEADERS.XAmzSecurityToken
    );
  } catch {
    return false;
  }
}
